var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeThreeTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 18.3346C5.39502 18.3346 1.66406 14.6036 1.66406 10.0013C1.66406 5.39893 5.39502 1.66797 9.9974 1.66797C14.5997 1.66797 18.3307 5.39893 18.3307 10.0013C18.3307 14.6036 14.5997 18.3346 9.9974 18.3346ZM9.9974 16.668C13.6793 16.668 16.6641 13.6832 16.6641 10.0013C16.6641 6.3194 13.6793 3.33464 9.9974 3.33464C6.3155 3.33464 3.33073 6.3194 3.33073 10.0013C3.33073 13.6832 6.3155 16.668 9.9974 16.668ZM10.8307 10.0013H14.1641V11.668H9.16406V5.83464H10.8307V10.0013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeThreeTime);
export default __webpack_public_path__ + "static/media/timeThreeTime.ef62c8a8224eaf6cfd822b11ab24154d.svg";
export { ForwardRef as ReactComponent };